import React from "react";
import { StyleSheet } from "react-native";
import * as DocumentPicker from "expo-document-picker";

import { kColors } from "src/kColors";
import { useModal } from "src/providers/OverlayProvider";

import { PdAttachment } from "src/components/Icons";
import { AlertModal, tAlertModalProps } from "src/components/Modals/AlertModal";
import { ComposerToolbarIconButton } from "./components";
import { useComposer } from "./utils";

const acceptedFiles = [
  "application/x-iwork-keynote-sffkey",
  "application/msword",
  "application/pdf",
  "application/vnd.ms-excel",
  "application/vnd.ms-powerpoint",
  "application/vnd.oasis.opendocument.text",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "image/png",
  "image/jpeg",
  "image/webp",
  "text/plain",
  "text/csv",
];

const AddAttachmentButton: React.FC = () => {
  const { addMessageFile } = useComposer();
  const alertModal = useModal<tAlertModalProps>(AlertModal);

  const onPress = async () => {
    const result = await DocumentPicker.getDocumentAsync({
      type: acceptedFiles.join(","),
    });
    if (result.type === "cancel") return;
    if (result.size > 3000000) {
      alertModal.openAsync({
        title: "Error",
        description:
          "This file exceeds the maximum size allowed. We recommend uploading this file on a shared drive (google, dropbox) and sharing the link with your customer.",
      });
      return;
    }
    if (result.file) {
      const { file } = result;
      addMessageFile?.({ name: file.name, type: file.type, size: file.size, url: result.uri });
    }
  };

  return <ComposerToolbarIconButton icon={<PdAttachment style={styles.composerIconSend} />} onPress={onPress} />;
};

export default AddAttachmentButton;

const styles = StyleSheet.create({
  composerIconSend: {
    color: kColors.gray500,
    width: 15,
  },
});
